import { Contact } from './contact';
import { Company } from './company';

export class CompanyContact extends Contact {
  company: Company = null;

  constructor() {
    super();
  }
}
